import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
/**
 * @class Abstract display backend module
 * @private
 */
var Backend = /*#__PURE__*/function () {
  function Backend() {
    _classCallCheck(this, Backend);
  }
  _createClass(Backend, [{
    key: "getContainer",
    value: function getContainer() {
      return null;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this._options = options;
    }
  }]);
  return Backend;
}();
export { Backend as default };